// extracted by mini-css-extract-plugin
module.exports = {"call":"call_call__1FlOg","callLight":"call_callLight__3fEVx","number":"call_number__3x9YF","link":"call_link__2mmgY","linkLight":"call_linkLight__2ejYE"};